<template>
  <b-card no-body class="mb-3 Namecard p-3 shadow border-0">
    <h5 >輸入電話</h5>
    <b-form-input v-model="phone" placeholder="請輸入分析電話號碼"  size="lg" maxlength="10" ></b-form-input>
    <p v-if="datecheck" class="invalid-feedback d-block m-0">
     {{datemsg}}
    </p>
  </b-card>
</template>
<style>
  .Namecard {
    border-radius: 1rem !important;
  }
</style>

<script>

export default {
  name: 'FormPhone',
  props: {

  },
  data() {
    return {
      datecheck:false,
      datemsg:'',
      phone:''
    }
  },
  methods: {
    toggleModal(){
      if(this.phone=='' || this.phone.length < 10 ){
        this.datecheck=true
        this.datemsg='請輸入完整10碼電話'
      }else {
        this.datecheck=false
        this.datemsg=''
        this.$emit('sendAction',this.phone);
      }
    },
    callaction () {


      this.datecheck=false
      this.datemsg=''
    },

  }
}
</script>
